import * as React from 'react';
import PartnersDashboard from 'src/modules/Dashboard/Partners/PartnersDashboard';
import ClubList from 'src/modules/Dashboard/Partners/club-list/ClubList';
import { Switch, Route } from 'react-router';
import { useAnalytics } from 'src/share/hooks/useAnalytics';

export const May2520 = () => {
  document.title = "ICMEC - Football Cares - May 25th";
  useAnalytics(process.env.REACT_APP_GOOGLE_ANALYTICS_MAY25_TRACKID as string)
  return (
    <Switch>
      <Route exact={true} path={'/clubs'}>
        <ClubList />
      </Route >
      <Route >
        <PartnersDashboard />
      </Route >
    </Switch>
  )
}